/**
 * HISI-FE-BRAND-01: API Configuration
 *
 * Single source of truth for API base URL configuration.
 * Single-brand HI-SI configuration without hostname detection.
 */

/**
 * Get the API base URL for HI-SI application
 */
export function getApiBaseUrl(): string {
  // Check environment variable first
  const envUrl = import.meta.env.VITE_API_BASE_URL;
  if (envUrl && envUrl.trim().length > 0) {
    return envUrl;
  }

  // Production: Always use HI-SI backend
  // Development: Use localhost
  return import.meta.env.DEV
    ? 'http://localhost:8080'
    : 'https://api.hi-si.ai';
}

// Export the computed API base URL
export const API_BASE_URL = getApiBaseUrl();

/**
 * Safely join API base URL with path segments
 * Prevents double /api or missing /api in URLs
 */
export function joinApiPath(...segments: string[]): string {
  const baseUrl = getApiBaseUrl();
  
  // Ensure base URL ends with /api
  const normalizedBase = baseUrl.endsWith('/api') 
    ? baseUrl 
    : baseUrl.replace(/\/+$/, '') + '/api';
  
  // Clean and join segments
  const cleanSegments = segments
    .map(segment => segment.replace(/^\/+|\/+$/g, '')) // Remove leading/trailing slashes
    .filter(segment => segment.length > 0);
  
  if (cleanSegments.length === 0) {
    return normalizedBase;
  }
  
  return normalizedBase + '/' + cleanSegments.join('/');
}